import WorkDaysListPage from '@/pages/workdays/list.tsx'

export default function ProjectWorkdaysPage() {
  return <WorkDaysListPage portalMode="project" />
}
